import * as types from '../../index';


export const subSectorListAction = (data) => {
    return {
    type: types.SUBSECTOR_LIST_SUPERADMIN,
    data
    }
};

export const subSectorAllListAction = (data) => {
    return {
    type: types.SUBSECTOR_ALL_LIST_SUPERADMIN,
    data
    }
};

export const subSectorAddAction = (data) => {
    return {
    type: types.SUBSECTOR_ADD_SUPERADMIN,
    data
    }
};

export const subSectorEditAction = (data) => {
    return {
    type: types.SUBSECTOR_EDIT_SUPERADMIN,
    data
    }
};

export const subSectorUpdateAction = (data) => {
    return {
    type: types.SUBSECTOR_UPDATE_SUPERADMIN,
    data
    }
};

export const subSectorDeleteAction = (data) => {
    return {
    type: types.SUBSECTOR_DELETE_SUPERADMIN,
    data
    }
};